import { jsx as _jsx } from "react/jsx-runtime";
/**
 * MultiUploadDropZoneHost
 *
 * Adapts the routing/API-agnostic drop zone from @shared/experimental
 * to the viewer's ingest API. Mount once near the top of the
 * authenticated tree.
 *
 * Every drop — onto the stream or into a collection — funnels through
 * `blockStore.add(...)` so we get the same optimistic placeholder
 * treatment everywhere: the card appears in the destination scope's
 * view in the same React commit as the drop, and the polling loop
 * swaps in the real envelope under the same client id when ingestion
 * completes.
 */
import React, { useMemo } from "react";
import { MultiUploadDropZone } from "@shared/experimental/multi-upload/multi-upload-drop-zone";
import { useRouteCollectionId } from "@shared/experimental/multi-upload/use-route-collection-id";
import { blockStore } from "@/data/block-store";
import { track } from "@/lib/analytics";
export const MultiUploadDropZoneHost = () => {
    const collectionId = useRouteCollectionId();
    const uploadFile = useMemo(() => async ({ file, collectionId: dropCollectionId }) => {
        track({
            name: "block.added",
            props: {
                input_method: "drag_drop",
                content_kind: "file",
                file_type: file.type || undefined,
                target: dropCollectionId != null ? "single_collection" : "stream",
                collection_count: dropCollectionId != null ? 1 : 0,
            },
        });
        await blockStore.add({
            files: [file],
            ...(dropCollectionId != null ? { collectionIds: [dropCollectionId] } : {}),
        });
    }, []);
    return (_jsx(MultiUploadDropZone, { uploadFile: uploadFile, ...(collectionId !== undefined ? { collectionId } : {}), acceptMimePrefixes: ["image/", "video/"] }));
};
